import * as React from 'react'
import { Paper, Button, makeStyles, Box, useMediaQuery } from '@material-ui/core'
import AutoCheckInput from '../components/AutoCheckInput'
import { useFeedback } from '../components/Feedback'
import axios from 'axios'
import { useHistory } from 'react-router'
import NationalCodeSelect from '../components/NationalCodeSelect'
import Logo from '../assets/Logo.png'
import { channelSignIn, sendChannelVerifyCode } from '../utils/api'
import { MobileVerifyType } from '../constants'
const useStyles = makeStyles({
    root: {

    },
    box: {
        width: '400px',
        margin: '15% auto',
        display: 'flex',
        flexDirection: 'column',
        padding: '20px',
        boxSizing: 'border-box'
    },
    input: {
        margin: '10px 0'
    }
})

const SignIn = () => {
    const { showLoading, hideLoading, showToast } = useFeedback();
    const history = useHistory()
    const [state, setState] = React.useState({
        username: '',
        password: '',
        mobile: '',
        vcode: '',
        nationalCode: '86'
    })
    const [usePassword, setUsePassword] = React.useState(true)
    const isMobile = useMediaQuery('(max-width: 768px)')

    const classes = useStyles()

    const [resendState, setResendState] = React.useState({
        resend: true,
        resendText: '发送验证码'
    })

    React.useEffect(() => {
        const timer = () => {
            let time = 60;
            return window.setInterval(() => {
                time--;
                if (time > 0) {
                    setResendState({ ...resendState, resendText: time + '' })
                } else {
                    setResendState({ ...resendState, resendText: '发送验证码', resend: true })
                }
            }, 1000)
        }
        let resendTimer: number;
        if (!resendState.resend) {
            resendTimer = timer()
        }
        return () => {
            resendTimer && window.clearInterval(resendTimer)
        }
    }, [resendState.resend])



    const handleInputChange = (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        setState({ ...state, [key]: event.target.value })
    }

    const buttonDisable = () => {
        if (usePassword) {
            return state.username && state.password
        } else {
            return state.mobile && state.vcode
        }
    }

    const handleLogin = () => {
        showLoading('登录中...')
        if (usePassword) {
            axios.post('/api/admin/login', { username: state.username, password: state.password }).then(res => {
                hideLoading()
                localStorage.setItem('user', res.data.type)
                history.replace(`/${res.data.type}/home`)
            }).catch(error => {
                hideLoading()
                let msg = '登录失败'
                if (error.response) {
                    msg += '，用户名或密码错误'
                }
                showToast(msg);
            })
        } else {
            channelSignIn(state.mobile, state.nationalCode, state.vcode).then(res => {
                hideLoading()
                localStorage.setItem('user', res.data.type)
                history.replace(`/${res.data.type}/home`)
            }).catch(error => {
                hideLoading()
                showToast(error.msg);
            })
        }
    }

    const handleSendVcode = () => {
        showLoading('发送中...')
        hideLoading()
        sendChannelVerifyCode(state.mobile, state.nationalCode, MobileVerifyType.signIn).then(res => {
            hideLoading()
            setResendState({ ...resendState, resend: false })
            showToast('验证码已发送');
        }).catch(error => {
            setResendState({ ...resendState, resend: true })
            hideLoading()
            showToast(error.msg)
        });
    }

    const switchSignInMethod = () => {
        setUsePassword(!usePassword);
    }

    const vcodeDisable = () => {
        return state.mobile && resendState.resend
    }


    const handleKeyUp = (event: React.KeyboardEvent<HTMLButtonElement | HTMLDivElement>) => {
        if (event.keyCode === 13) {
            handleLogin()
        }
    }

    return <Box p={2}>
        <Paper className={classes.box} style={{ width: isMobile ? 'auto' : '400px' }}>
            <Box display="flex" justifyContent="center" mb={4}>
                <img src={Logo} width="80px" height="80px" />
            </Box>
            {usePassword ? <AutoCheckInput notNull label="用户名" onKeyUp={handleKeyUp} onChange={handleInputChange('username')} value={state.username} /> :
                <AutoCheckInput
                    InputProps={{
                        startAdornment: <NationalCodeSelect value={state.nationalCode} onChange={handleInputChange('nationalCode')} />
                    }}
                    type="tel" nationalCode={state.nationalCode} label="手机号" notNull mobile value={state.mobile} onChange={handleInputChange('mobile')} />
            }
            {usePassword ? <AutoCheckInput notNull label="密码" onKeyUp={handleKeyUp} onChange={handleInputChange('password')} value={state.password} type="password" /> :
                <Box display="flex" alignItems="baseline">
                    <AutoCheckInput type="number" style={{ flexGrow: 1 }} label={'验证码'} notNull value={state.vcode} onChange={handleInputChange('vcode')} />
                    <Button style={{ width: '160px', flexShrink: 0 }} variant="text" disabled={!vcodeDisable()} onClick={handleSendVcode} color="secondary">{resendState.resendText}</Button>
                </Box>
            }
            <Button onClick={switchSignInMethod} variant="text">{usePassword ? '使用手机验证码登录' : '使用密码登录'}</Button>
            <Button onClick={handleLogin} onKeyUp={handleKeyUp} disabled={!buttonDisable()} style={{ marginTop: '8px', color: '#fff' }}>登录</Button>
        </Paper>
    </Box>
}
export default SignIn